import React from "react";
import ProfileImage from "../../UI/ProfileImage/ProfileImage";
import Button from "../../UI/Button/Button";
// import './StatusContinue.scss';
import GlobalStore from "../../store/globalStore";
import {
  AGetStageCompletionStatus,
} from "../../Services/registration/continueApiService";
import ErrMsg from "../../UI/ErrMsg/ErrMsg";
// import { useHistory } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { dashboardUrl, containerUrl, statusUrl } from "../../utils/constants";
import { ageCalculator, setStageData } from "../../Services/globalService";
import welcomeBack from "../../../assets/icons/welcomeBack.jpg";
// Single source of truth for navbar / Cache / KRA / getStatus-navigation logic.
import {
  checkModuleCompleteness,
  markStepIncomplete,
  resolveCacheThenKra,
  applyKraResponseToStore,
} from "../../Services/navigationOrchestrator";
import {
  AGetClientDetailsByPan,
  AGetPanUtiData,
} from "../../Services/registration/panDobApiService";
import { APendingUploadList } from "../../Services/dashboard/eSignApiServices";
import { errorMessage } from "../../utils/errorMessage";
import { pan } from "../../utils/regex";
import { getProfileDetailsFromAadhar } from "../../Registration/ShareAdd/ShareAdd";
import { decryptJwtToken } from "../../Services/dashboard/encryptionNew";
import { ITokenObj } from "../../types/genericTypes";
import moment from "moment";
export interface StatusContinueProps { }

const StatusContinue: React.FC<StatusContinueProps> = (props) => {
  const [dematAccountFound, setDematAccountFound] = React.useState<any>(null);

  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [clientName, setClientName] = React.useState<string>("");
  const [panValue, setPanValue] = React.useState<string>("");
  const [errCode, setErrCode] = React.useState<number | string>();
  // const [isUploadDocumentsCompleted, setIsUploadDocumentsCompleted] = React.useState<boolean>(false);
  let isUploadDocumentsCompleted = false;
  // const history = useHistory();
  const navigate = useNavigate()
  const getPAN = async () => {
    const panFromLocalStorage = await JSON.parse(
      window.localStorage.getItem("clientPartialDetails_ao") || "{}"
    );

    let panNum = GlobalStore.personaldetails.pan;

    if (
      GlobalStore.personaldetails.pan != undefined ||
      GlobalStore.personaldetails.pan != ""
    ) {
      panNum = GlobalStore.personaldetails.pan;
    } else if (panFromLocalStorage.pan != "") {
      panNum = panFromLocalStorage.pan != "" ? panFromLocalStorage.pan : "";
    }
    let isValidPan = pan.test(panNum);
    return panNum;
  };
  const handleContinue = async () => {
    // e.preventDefault();
    console.log("function called");

    setIsLoading(true);
    const panFromLocalStorage = await JSON.parse(
      window.localStorage.getItem("clientPartialDetails_ao") || "{}"
    );

    let panNum = GlobalStore.personaldetails.pan;

    if (
      GlobalStore.personaldetails.pan != undefined ||
      GlobalStore.personaldetails.pan != ""
    ) {
      panNum = GlobalStore.personaldetails.pan;
    } else if (panFromLocalStorage.pan != "") {
      panNum = panFromLocalStorage.pan != "" ? panFromLocalStorage.pan : "";
    }
    let isValidPan = pan.test(panNum);

    console.log(
      "panNum",
      { panNum, isValidPan },
      panNum !== "" && panNum !== undefined && isValidPan
    );
    if (panNum !== "" && panNum !== undefined && isValidPan) {
      setPanValue(panNum);
      AGetPanUtiData(validatePAN, panNum);
    } else {
      alert(
        "Please restart or check your status to continue with your Account Opening process as current session is expired."
      );
      // history.push(containerUrl.registration);
      navigate(containerUrl.registration)
      return;
    }
  };

  // function validatePAN(res: any) {
  //   if (!res || res.error) {
  //     // setErrCode(107);
  //     // setErrCode(errorMessage.validatePAN);
  //     console.log(res.errMsg);
  //     setErrCode(res.error);

  //     setIsLoading(false);
  //   } else {
  //     if (
  //       res &&
  //       res.data &&
  //       res.data.panDetails &&
  //       res.data.panDetails?.AadharSeedingStatus.indexOf(
  //         "Existing and Valid"
  //       ) !== -1
  //     ) {
  //       let PANFirstName = res.data.panDetails.Firstname
  //         ? res.data.panDetails.Firstname
  //         : "";
  //       let PANMiddleName = res.data.panDetails.Middlename
  //         ? res.data.panDetails.Middlename
  //         : "";
  //       let PANlastName = res.data.panDetails.Lastname
  //         ? res.data.panDetails.Lastname
  //         : "";

  //       if (PANFirstName === "null" && PANlastName !== "null") {
  //         PANFirstName = PANlastName;
  //         GlobalStore.personaldetails.PANName = PANFirstName;
  //         PANlastName = "";
  //         if (PANMiddleName !== "null") {
  //           GlobalStore.personaldetails.PANName =
  //             GlobalStore.personaldetails.PANName + " " + PANMiddleName;
  //         }
  //       } else if (
  //         PANFirstName === "null" &&
  //         PANMiddleName === "null" &&
  //         PANlastName === "null"
  //       ) {
  //         GlobalStore.personaldetails.PANName = "";
  //       } else if (PANMiddleName === "null") {
  //         GlobalStore.personaldetails.PANName =
  //           PANFirstName + " " + PANlastName;
  //         PANMiddleName = "";
  //       } else {
  //         GlobalStore.personaldetails.PANName =
  //           PANFirstName + " " + PANMiddleName + " " + PANlastName;
  //       }

  //       //Modify personal details based on this response.

  //       GlobalStore.personaldetails.firstname = PANFirstName;
  //       GlobalStore.personaldetails.lastname = PANlastName;
  //       GlobalStore.personaldetails.middlename = PANMiddleName;
  //       GlobalStore.personaldetails.panDetails = res.data.panDetails;
  //       AGetClientDetailsByPan(searchByPan, GlobalStore.personaldetails.pan);
  //     } else if (
  //       res &&
  //       res.data &&
  //       res.data.panDetails &&
  //       res.data.panDetails?.AadharSeedingStatus.indexOf("Invalid PAN") === -1
  //     ) {
  //       setErrCode(errorMessage.newPanUtiError);
  //       setIsLoading(false);
  //     } else if (
  //       res &&
  //       res.data &&
  //       res.data.panDetails &&
  //       res.data.panDetails?.AadharSeedingStatus.indexOf(
  //         "Not in ITD Database"
  //       ) === -1
  //     ) {
  //       setErrCode(errorMessage.newPanUtiError);
  //       setIsLoading(false);
  //     } else {
  //       setErrCode(errorMessage.newPanUtiError);
  //       setIsLoading(false);
  //     }
  //   }
  // }

  function validatePAN(res: any) {
    if (!res || res.error) {
      // setErrCode('107  - Error in fetching Pan details from PAN UTI system.');
      setErrCode(res.error);
      console.log(res.errMsg);
      setIsLoading(false);
    } else {
      console.log("PANlastName", res.data);

      if (res && res.data && res.data.PanNo && res.data.IsValid == true) {
        //CleverTap log Start
        // var data = {
        //     CurrentPage: $location.path(),
        //     Platform: angular.element($window).width() > 767 ? 'Website_Desktop' : 'Website_Mobile',
        //     EventName: 'pan_dob_success',
        //     CTA: 'Continue'
        // };
        // clevertap.event.push(data.EventName, data);
        //CleverTap log End

        let PANFirstName = res.data.Firstname ? res.data.Firstname : "";
        let PANMiddleName = res.data.Middlename ? res.data.Middlename : "";
        let PANlastName = res.data.Lastname ? res.data.Lastname : "";

        if (PANFirstName === "" && PANlastName !== "") {
          PANFirstName = PANlastName;
          GlobalStore.personaldetails.PANName = PANFirstName;
          PANlastName = "";
          if (PANMiddleName !== "") {
            GlobalStore.personaldetails.PANName =
              GlobalStore.personaldetails.PANName + " " + PANMiddleName;
          }
        } else if (
          PANFirstName === "" &&
          PANMiddleName === "" &&
          PANlastName === ""
        ) {
          GlobalStore.personaldetails.PANName = "";
        } else if (PANMiddleName === "") {
          GlobalStore.personaldetails.PANName =
            PANFirstName + " " + PANlastName;
          PANMiddleName = "";
        } else {
          GlobalStore.personaldetails.PANName =
            PANFirstName + " " + PANMiddleName + " " + PANlastName;
        }

        //Modify personal details based on this response.

        GlobalStore.personaldetails.firstname = PANFirstName;
        GlobalStore.personaldetails.lastname = PANlastName;
        GlobalStore.personaldetails.middlename = PANMiddleName;
        GlobalStore.personaldetails.panDetails = res.data;

        let responseObj = res.data.AadharSeedingStatus
          ? res.data.AadharSeedingStatus
          : "";

        if (responseObj.includes("Aadhaar not Seeded")) {
          GlobalStore.isSeeding = false;
        } else if (responseObj.includes("Aadhaar Seeding is Successful")) {
          GlobalStore.isSeeding = true;
        }

        //-------- After Pan validation Navigate to DigiLocker Page -------
        let userId = "0";
        console.log("searchByPan token", decryptJwtToken(GlobalStore?.token));
        const tokenObj: string = decryptJwtToken(GlobalStore?.token);
        if (tokenObj !== "" && !!tokenObj && tokenObj?.length > 0) {
          let tokenMainObj: ITokenObj = JSON.parse(tokenObj) as ITokenObj;
          userId = tokenMainObj?.UserId?.toString();
        }
        const clientPartialDetails_ao = JSON.parse(
          window.localStorage.getItem("clientPartialDetails_ao") || "{}"
        );
        let accountCategory = 0;
        if (
          GlobalStore?.accountcategory !== undefined &&
          GlobalStore?.accountcategory !== null
        ) {
          accountCategory = GlobalStore?.accountcategory;
        } else {
          accountCategory = clientPartialDetails_ao?.accountcategory;
        }
        //Dudupe Logic here//
        AGetClientDetailsByPan(
          searchByPan,
          GlobalStore.personaldetails.pan,
          accountCategory,
          userId
        );
      } else if (
        res &&
        res.data &&
        res.data.PanNo &&
        res.data.IsValid == false
      ) {
        // setErrCode('Not in ITD Database. Please enter valid PAN.');
        setErrCode(res.error);
        setIsLoading(false);
        //CleverTap log start
        // var data = {
        //     CurrentPage: $location.path(),
        //     Platform: angular.element($window).width() > 767 ? 'Website_Desktop' : 'Website_Mobile',
        //     EventName: 'pan_dob_failure',
        //     Error: 'Not in ITD Database.Please enter valid PAN'
        // };
        // clevertap.event.push(data.EventName, data);
        //CleverTap log end
        // } else if (
        //     res &&
        //     res.data &&
        //     res.data.panDetails &&
        //     res.data.panDetails.indexOf('Not in ITD Database') === -1
        // ) {
        //     // setErrCode('Not in ITD Database.Please enter valid PAN.');
        //     setErrCode(errorMessage.clientDetailsByPan);
        //     setIsLoading(false);
        //CleverTap log start
        // var data = {
        //     CurrentPage: $location.path(),
        //     Platform: angular.element($window).width() > 767 ? 'Website_Desktop' : 'Website_Mobile',
        //     EventName: 'pan_dob_failure',
        //     Error: 'Not in ITD Database.Please enter valid PAN'
        // };
        // clevertap.event.push(data.EventName, data);
        //CleverTap log end
      } else {
        // setErrCode('PAN UTI server down');
        setErrCode(res.error);
        setIsLoading(false);
      }
    }
  }

  const searchByPan = (res: any) => {
    if (!res || res.error) {
      // setErrCode(118);
      setErrCode(res.error);
      setIsLoading(false);
    } else {
      if (res.data) {
        if (res.data != null) {
          GlobalStore.personaldetails.pan = res.data.PAN;
          GlobalStore.token = res.data.Token;
          GlobalStore.applicationID = res.data.ApplicatoinId;
          GlobalStore.entityType = res?.data?.entitytype
          GlobalStore.entitySubType = res?.data?.entitysubtype
          GlobalStore.leadId = res.data.LeadId;
          GlobalStore.clientPrimaryDetailId = res.data.ClientPrimaryDetailId;
          GlobalStore.isPANVerified = true;
          const clientPartialDetails_ao = JSON.parse(
            window.localStorage.getItem("clientPartialDetails_ao") || "{}"
          );
          clientPartialDetails_ao.isPANVerified = GlobalStore.isPANVerified;
          clientPartialDetails_ao.leadID = res.data.LeadId;
          clientPartialDetails_ao.pan = res.data?.PAN;
          clientPartialDetails_ao.clientPrimaryDetailId =
            res.data.ClientPrimaryDetailId;
          clientPartialDetails_ao.applicationId = res.data.ApplicatoinId;
          clientPartialDetails_ao.accountcategory = res.data.AccountCategory;
          clientPartialDetails_ao.token = res.data.Token
            ? res.data.Token
            : GlobalStore?.token;
          clientPartialDetails_ao.clientPrimaryDetailId =
            GlobalStore.clientPrimaryDetailId;
          window.localStorage.setItem(
            "clientPartialDetails_ao",
            JSON.stringify(clientPartialDetails_ao)
          );

          // AGetStageCompletionStatus(getClientStageDetails, GlobalStore.applicationID);
          APendingUploadList(
            checkPendingUpload,
            res.data.ApplicatoinId
              ? res.data.ApplicatoinId
              : GlobalStore.applicationID
          );
        } else if (res.data == null) {
          setErrCode("No records found");
        }
      } else {
        setErrCode(res.error);
        setIsLoading(false);
      }
    }
  };

  function checkPendingUpload(res: any) {
    let dematAccountFoundLocaL: any = null,
      addressAccountFoundLocal: any = null;
    setIsLoading(true);
    if (!res || res.error) {
      setErrCode(res.error);
    } else {
      if (res && res.data) {
        let list: Array<any> = JSON.parse(res.data).filter(
          (item: any) =>
            // Prev api response
            // item.documentcategoryid !== 36 &&
            // item.documentcategoryid !== 30 &&
            // item.documentcategoryid !== 62
            item.Mandatory == true
        );
        if (
          list !== undefined &&
          list !== null &&
          list?.length > 0 &&
          list?.length === 1
        ) {
          addressAccountFoundLocal = list.find(
            (listObj) =>
              (listObj?.DocumentCategory == "Address Proof Permanent" &&
                listObj?.DocumentCategoryId == 4) ||
              (listObj?.DocumentCategory == "Address Proof Correspondence" &&
                listObj?.DocumentCategoryId == 3)
          );
          dematAccountFoundLocaL = list.find(
            (listObj) =>
              listObj?.DocumentCategory == "DP Document" &&
              listObj?.DocumentCategoryId == 96
          );
          if (
            dematAccountFoundLocaL !== undefined &&
            dematAccountFoundLocaL !== null
          ) {
            setDematAccountFound(dematAccountFoundLocaL);
          }
        } else if (
          list !== undefined &&
          list !== null &&
          list?.length > 0 &&
          list?.length > 1
        ) {
          addressAccountFoundLocal = list.find(
            (listObj) =>
              (listObj?.DocumentCategory == "Address Proof Permanent" &&
                listObj?.DocumentCategoryId == 4) ||
              (listObj?.DocumentCategory == "Address Proof Correspondence" &&
                listObj?.DocumentCategoryId == 3)
          );
          dematAccountFoundLocaL = list.find(
            (listObj) =>
              listObj?.DocumentCategory == "DP Document" &&
              listObj?.DocumentCategoryId == 96
          );
          if (
            dematAccountFoundLocaL !== undefined &&
            dematAccountFoundLocaL !== null
          ) {
            setDematAccountFound(dematAccountFoundLocaL);
          }
        }

        if (list.length === 0 || list[0].count === 0)
          isUploadDocumentsCompleted = true;
      }
    }
    setIsLoading(false);
    AGetStageCompletionStatus((res: any) => {
      getClientStageDetails(res, dematAccountFoundLocaL);
    }, GlobalStore.applicationID);
  }
  const convertDate = (dateString: string) => {
    // Split the input date string by "/"
    const [day, month, year] = dateString.split("/");

    // Create a new Date object with the parsed values
    const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day)); // month - 1 because months are zero-indexed

    // Format the date to "mm-dd-yyyy"
    const formattedDate = `${(date.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${day.padStart(2, "0")}-${year}`;

    return formattedDate;
  };

  /**
   * Cache -> KRA -> fallback cascade, delegated to the centralized
   * navigationOrchestrator (resolveCacheThenKra). Only the per-outcome side
   * effects that are genuinely specific to StatusContinue (the reload flow)
   * are kept here:
   *   - on a live-KRA-invalid result, StatusContinue always sends the
   *     client to DigiLocker (unlike WelcomeBack, which additionally checks
   *     `applicationId.includes("I")` to decide Personal Info vs DigiLocker).
   *   - the "no cache, no dob/pan to check" fallback is caller-supplied
   *     (see call site below), matching the legacy behavior exactly.
   */
  const resolveCacheAndKraForClient = (
    onNoCacheNoKraFallback: () => void,
    dob?: any
  ) => {
    resolveCacheThenKra({
      applicationID: GlobalStore.applicationID,
      dob,
      pan: GlobalStore.personaldetails.pan,
      clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId,
      leadId: GlobalStore.leadId,
      createdBy: 0,
      entityType: GlobalStore.entityType,
      onKraFromCache: (data: any) => {
        applyKraResponseToStore(data, { setGender: true });
        navigate(dashboardUrl.profile);
        setIsLoading(false);
      },
      onDigiLockerFromCache: (data: any) => {
        GlobalStore.isDigiLocker = true;
        const clientPartialDetails_ao = JSON.parse(
          window.localStorage.getItem("clientPartialDetails_ao") || "{}"
        );
        clientPartialDetails_ao.isDigiLocker = true;
        clientPartialDetails_ao.signzydt = "";
        window.localStorage.setItem(
          "clientPartialDetails_ao",
          JSON.stringify(clientPartialDetails_ao)
        );
        getProfileDetailsFromAadhar(data);
        navigate(dashboardUrl.profile);
        setIsLoading(false);
      },
      onNormalClientFromCache: (data: any) => {
        GlobalStore.isNormalClient = true;
        GlobalStore.isKYC = false;
        GlobalStore.isKRA = false;
        const clientPartialDetails_ao = JSON.parse(
          window.localStorage.getItem("clientPartialDetails_ao") || "{}"
        );
        clientPartialDetails_ao.isKRA = GlobalStore.isKRA;
        clientPartialDetails_ao.isKYC = GlobalStore.isKYC;
        clientPartialDetails_ao.addressLine1 =
          data.PermanentAddressDetails.PermanentAddressLine1;
        clientPartialDetails_ao.addressLine1 +=
          data.PermanentAddressDetails.PermanentAddressLine2;
        clientPartialDetails_ao.addressLine1 +=
          data.PermanentAddressDetails.PermanentAddressLine3;
        clientPartialDetails_ao.addressLine1 +=
          data.PermanentAddressDetails.PermanentAddressLine4;
        clientPartialDetails_ao.sameAsPermanent =
          data.corrsaddraspermanent !== null &&
            data.corrsaddraspermanent !== undefined
            ? data.corrsaddraspermanent
            : true;
        clientPartialDetails_ao.corrAddress =
          data.CorrespondenceAddressDetails.CorrespondenceAddressLine1;
        clientPartialDetails_ao.corrAddress +=
          data.CorrespondenceAddressDetails.CorrespondenceAddressLine2;
        clientPartialDetails_ao.corrAddress +=
          data.CorrespondenceAddressDetails.CorrespondenceAddressLine3;
        clientPartialDetails_ao.corrAddress +=
          data.CorrespondenceAddressDetails.CorrespondenceAddressLine4;
        clientPartialDetails_ao.isSeniorCitizen =
          window.sessionStorage.getItem("isSeniorCitizen") === "true"
            ? true
            : false;
        clientPartialDetails_ao.clientPrimaryDetailId =
          GlobalStore.clientPrimaryDetailId;
        clientPartialDetails_ao.dob = GlobalStore.dob;
        clientPartialDetails_ao.emailID = GlobalStore.user.email;
        clientPartialDetails_ao.PinCode =
          data.PermanentAddressDetails.PermanentPincode;
        clientPartialDetails_ao.corrPincode =
          data.CorrespondenceAddressDetails.CorrespondencePincode;
        clientPartialDetails_ao.isNormalClient = GlobalStore.isNormalClient;
        clientPartialDetails_ao.leadID = GlobalStore.leadId;
        clientPartialDetails_ao.mobile = GlobalStore.user.mobile;
        clientPartialDetails_ao.pan = GlobalStore?.personaldetails?.pan;
        clientPartialDetails_ao.panDetails =
          GlobalStore.personaldetails.panDetails;
        clientPartialDetails_ao.token = GlobalStore.token;
        clientPartialDetails_ao.isSeeding = GlobalStore.isSeeding;
        clientPartialDetails_ao.isKRA = GlobalStore.isKRA;
        clientPartialDetails_ao.isKYC = GlobalStore.isKYC;
        clientPartialDetails_ao.isNormalClient = GlobalStore.isNormalClient;
        window.localStorage.setItem(
          "clientPartialDetails_ao",
          JSON.stringify(clientPartialDetails_ao)
        );
        navigate(dashboardUrl.profile);
        setIsLoading(false);
      },
      onKraValid: () => {
        navigate(dashboardUrl.profile);
        setIsLoading(false);
      },
      onKraInvalid: () => {
        // StatusContinue-specific: always DigiLocker on KRA-invalid (no
        // applicationId.includes("I") branch like WelcomeBack).
        GlobalStore.isNormalClient = true;
        GlobalStore.isKYC = false;
        GlobalStore.isKRA = false;
        const clientPartialDetails_ao = JSON.parse(
          window.localStorage.getItem("clientPartialDetails_ao") || "{}"
        );
        clientPartialDetails_ao.isKRA = GlobalStore.isKRA;
        clientPartialDetails_ao.isKYC = GlobalStore.isKYC;
        clientPartialDetails_ao.isSeniorCitizen =
          window.sessionStorage.getItem("isSeniorCitizen") === "true"
            ? true
            : false;
        clientPartialDetails_ao.clientPrimaryDetailId =
          GlobalStore.clientPrimaryDetailId;
        clientPartialDetails_ao.dob = GlobalStore.dob;
        clientPartialDetails_ao.emailID = GlobalStore.user.email;
        clientPartialDetails_ao.isNormalClient = GlobalStore.isNormalClient;
        clientPartialDetails_ao.leadID = GlobalStore.leadId;
        clientPartialDetails_ao.mobile = GlobalStore.user.mobile;
        clientPartialDetails_ao.pan = GlobalStore?.personaldetails?.pan;
        clientPartialDetails_ao.panDetails =
          GlobalStore.personaldetails.panDetails;
        clientPartialDetails_ao.token = GlobalStore.token;
        clientPartialDetails_ao.isSeeding = GlobalStore.isSeeding;
        clientPartialDetails_ao.isKRA = GlobalStore.isKRA;
        clientPartialDetails_ao.isKYC = GlobalStore.isKYC;
        clientPartialDetails_ao.isNormalClient = GlobalStore.isNormalClient;
        window.localStorage.setItem(
          "clientPartialDetails_ao",
          JSON.stringify(clientPartialDetails_ao)
        );
        navigate(containerUrl.dgLocker);
        setIsLoading(false);
      },
      onKraError: (res: any) => {
        setErrCode(res.error);
        setIsLoading(false);
      },
      onNoKraFallback: onNoCacheNoKraFallback,
    });
  };
  async function getClientStageDetails(
    res: any,
    dematAccountFoundLocaL?: any,
    addressRejctedFound?: any
  ) {
    setIsLoading(true);
    if (!res || res.error) {
      // setErrCode(106);
      setErrCode(res.error);
    } else {
      if (res.data) {
        const responseObj = JSON.parse(res.data);

        //set stage api data to GlobalStore
        setStageData(responseObj);
        //check completeness of stages
        checkModuleCompleteness(
          isUploadDocumentsCompleted,
          dematAccountFoundLocaL ? dematAccountFoundLocaL : dematAccountFound,
          addressRejctedFound
        );
        GlobalStore.personaldetails.fsfullName = GlobalStore.personaldetails
          .fsfullName
          ? GlobalStore.personaldetails.fsfullName
          : responseObj?.fatherspousename;
        if (responseObj.isdigilockercompleted) GlobalStore.isDigiLocker = true;
        if (responseObj.iskra) GlobalStore.isKRA = true;
        if (responseObj.iskyc) GlobalStore.isKYC = true;

        console.log("responseObj", responseObj);
        GlobalStore.pennyDropCount = responseObj.pennydropcount;

        const clientPartialDetails_ao = JSON.parse(
          window.localStorage.getItem("clientPartialDetails_ao") || "{}"
        );
        clientPartialDetails_ao.applicationId = GlobalStore.applicationID;
        clientPartialDetails_ao.token = GlobalStore.token;
        clientPartialDetails_ao.leadID = GlobalStore.leadId;
        clientPartialDetails_ao.PANName = GlobalStore.personaldetails.PANName;
        clientPartialDetails_ao.panDetails =
          GlobalStore.personaldetails.panDetails;
        clientPartialDetails_ao.isDigiLocker = GlobalStore.isDigiLocker;
        clientPartialDetails_ao.isKRA = GlobalStore.stageStatus.iskra;
        clientPartialDetails_ao.isKYC = GlobalStore.stageStatus.iskyc;
        clientPartialDetails_ao.mobile = responseObj?.mobileno;
        clientPartialDetails_ao.emailID = responseObj.emailid;
        clientPartialDetails_ao.dob = GlobalStore.stageStatus.dob; //moment(values.dob).format("DD/MM/YYYY");
        if (
          responseObj?.fatherspousename != null &&
          responseObj?.fatherspousename != undefined &&
          responseObj?.fatherspousename !== ""
        ) {
          clientPartialDetails_ao.fsfullName = responseObj?.fatherspousename;
        }
        clientPartialDetails_ao.isKYC = GlobalStore.stageStatus.iskyc;
        clientPartialDetails_ao.pennyDropCount = GlobalStore.pennyDropCount;
        if (responseObj?.dob !== null && responseObj?.dob !== undefined) {
          let date = moment(moment(convertDate(responseObj?.dob)).toDate())
            .startOf("day")
            .toDate();
          if (date !== null && date !== undefined && ageCalculator(date) > 60) {
            window.sessionStorage.setItem("isSeniorCitizen", "true");
          } else {
            window.sessionStorage.setItem("isSeniorCitizen", "false");
          }
        }
        if (addressRejctedFound !== null && addressRejctedFound !== undefined) {
          markStepIncomplete(dashboardUrl.personalIfo);
        }
        if (
          responseObj?.fatherspousename != null &&
          responseObj?.fatherspousename != undefined &&
          responseObj?.fatherspousename !== ""
        ) {
          clientPartialDetails_ao.fsfullName = responseObj?.fatherspousename;
        }
        window.localStorage.setItem(
          "clientPartialDetails_ao",
          JSON.stringify(clientPartialDetails_ao)
        );

        //route according to stage api response
        if (!responseObj?.second_esign_req && responseObj?.isesigncompleted) {
          // history.push(containerUrl.submit);
          navigate(containerUrl.submit)
          return
        }
        if (responseObj.bpm_pd_status == 2 && addressRejctedFound && !responseObj?.isotc) {
          // history.push(dashboardUrl.personalIfo);
          navigate(dashboardUrl.personalIfo)
          return;
        }
        if (
          responseObj.applicationstatus === 1 &&
          responseObj.bpm_pd_status === 0
        ) {
          // history.push(statusUrl.docVerificationInProgress);
          navigate(statusUrl.docVerificationInProgress)
          return;
        }
        if (
          responseObj.isesigncompleted !== null &&
          responseObj.isesigncompleted == true &&
          responseObj?.auth_ver &&
          responseObj?.accountcategory === 2 &&
          responseObj?.elog_opted &&
          responseObj.isKra
        ) {
          // history.push(statusUrl.elogVerificationInProgress);
          navigate(statusUrl.elogVerificationInProgress)
          return
        }
        if (
          responseObj.isesigncompleted !== null &&
          responseObj.isesigncompleted == true &&
          responseObj?.auth_ver &&
          responseObj?.accountcategory === 2
        ) {
          // history.push(containerUrl.esignsubmit);
          navigate(containerUrl.esignsubmit)
          return;
        }
        if (!isUploadDocumentsCompleted && responseObj.bpm_pd_status === 2) {
          // history.push(statusUrl.documentReject);
          navigate(statusUrl.documentReject)
          return;
        }
        if (
          !responseObj.isdigilockercompleted &&
          GlobalStore.aadharLinkedChoice &&
          !GlobalStore.isDigiLocker &&
          !GlobalStore.isKRA
        ) {
          // history.push(containerUrl.dgLocker);
          navigate(containerUrl.dgLocker)
          return;
        }
        if (
          !(
            responseObj.isprofiledetailscompleted &&
            responseObj.ispersonaldetailscompleted
          )
        ) {
          resolveCacheAndKraForClient(() => {
            alert(
              "Please restart/continue with your Account Opening process"
            );
            // history.push(containerUrl.registration);
            navigate(containerUrl.registration)
          }, responseObj?.dob);
          return;
          // alert("Please restart/continue with your Account Opening process");
          // history.push(containerUrl.registration);
          navigate(containerUrl.registration)
          // return;
        }
        if (!responseObj.isbankdetailscompleted) {
          // history.push(dashboardUrl.bank);
          navigate(dashboardUrl.bank)
          return;
        }
        if (responseObj?.accountcategory === 2 && !responseObj?.isdpcompleted) {
          // history.push(dashboardUrl.demat);
          navigate(dashboardUrl.demat)
          return;
        }
        if (
          responseObj?.accountcategory !== 2 &&
          (!responseObj.isbrokeragesegmentcompleted ||
            !responseObj.isbrokerageschemecompleted)
        ) {
          // history.push(dashboardUrl.plan);
          navigate(dashboardUrl.plan)
          return;
        }
        if (!isUploadDocumentsCompleted) {
          // history.push(dashboardUrl.doc);
          navigate(dashboardUrl.doc)
          return;
        }
        if (
          !GlobalStore.isDigiLocker &&
          !GlobalStore.isKRA &&
          !GlobalStore.isKYC &&
          !responseObj.isipvarificationcompleted
        ) {
          // history.push(dashboardUrl.ipv);
          navigate(dashboardUrl.ipv)
          return;
        }
        if (responseObj.isagentvisitcompleted) {
          // history.push(containerUrl.ocv);
          navigate(containerUrl.ocv)
          return;
        }
        if (
          responseObj.iskra !== null &&
          responseObj.iskra !== undefined &&
          responseObj.iskra &&
          responseObj?.accountcategory === 2
        ) {
          let userId = "0";
          //console.log("searchByPan token", decryptJwtToken(GlobalStore?.token));
          const tokenObj: string = decryptJwtToken(GlobalStore?.token);
          if (tokenObj !== "" && !!tokenObj && tokenObj?.length > 0) {
            let tokenMainObj: ITokenObj = JSON.parse(tokenObj) as ITokenObj;
            userId = tokenMainObj?.UserId?.toString();
          }
          if (userId !== "0" && responseObj?.auth_ver) {
            if (
              responseObj.iskra !== null &&
              responseObj.iskra !== undefined &&
              responseObj?.auth_ver &&
              responseObj?.elog_opted &&
              responseObj.isKra
            ) {
              // history.push(statusUrl.elogVerificationInProgress);
              navigate(statusUrl.elogVerificationInProgress)
            }
            else if (
              responseObj.iskra !== null &&
              responseObj.iskra !== undefined &&
              responseObj?.auth_ver &&
              responseObj.applicationstatus === 1 &&
              responseObj.bpm_pd_status === 1
            ) {
              // history.push(containerUrl.esignsubmit);
              navigate(containerUrl.esignsubmit)
            } else {
              if (
                responseObj.isesigncompleted !== null &&
                responseObj.isesigncompleted == true &&
                responseObj?.auth_ver &&
                responseObj?.accountcategory === 2 &&
                responseObj?.elog_opted &&
                responseObj.isKra
              ) {
                // history.push(statusUrl.elogVerificationInProgress);
                navigate(statusUrl.elogVerificationInProgress)
              } else if (
                responseObj.isesigncompleted !== null &&
                responseObj.isesigncompleted == true &&
                responseObj?.auth_ver &&
                responseObj?.accountcategory === 2 &&
                responseObj.applicationstatus === 1 &&
                responseObj.bpm_pd_status === 1
              ) {
                // history.push(containerUrl.esignsubmit);
                navigate(containerUrl.esignsubmit)
              } else if (
                responseObj.applicationstatus === 1 &&
                responseObj.bpm_pd_status === 1
              )
                // history.push(containerUrl.kycsubmit);
                navigate(containerUrl.kycsubmit)
            }
            return;
          } else {
            if (
              responseObj.bpm_pd_status === 1 &&
              responseObj.applicationstatus === 1 &&
              responseObj?.auth_ver
            ) {
              // history.push(containerUrl.submit);
              navigate(containerUrl.submit)
              return;
            } else {
              // history.push(dashboardUrl.authenticate);
              navigate(dashboardUrl.authenticate)
              return;
            }
          }
        }
        if (!responseObj.isesigncompleted) {
          // history.push(dashboardUrl.eSign + "?sc=e");
          navigate(dashboardUrl.eSign + "?sc=e")
          return;
        }
        if (responseObj.isesigncompleted && !responseObj?.second_esign_req) {
          // history.push(containerUrl.submit);
          navigate(containerUrl.submit)
          return;
        }
        if (
          responseObj?.isesigncompleted &&
          responseObj?.accountcategory === 2
        ) {
          // history.push(containerUrl.submit);
          navigate(containerUrl.submit)
          return;
        }
        if (responseObj.isesigncompleted && !responseObj.iskraesigncompleted) {
          // history.push(dashboardUrl.eSign + "?sc=k");
          navigate(dashboardUrl.eSign + "?sc=k")
          return;
        }
        if (responseObj.bpm_pd_status === 1) {
          // history.push(containerUrl.poa);
          navigate(containerUrl.poa)
          return;
        }
      }
    }
    setIsLoading(false);
  }

  return (
    <div className="wb">
      <div className="wbLogo">
        <ProfileImage>
          <img src={welcomeBack} alt="" aria-hidden="true" className="pfImg" />
        </ProfileImage>
      </div>
      <h1 className="wbheading">
        Welcome Back {clientName}
      </h1>
      <div className="wbInfo">
        <p className="infoLine">
          Your form is incomplete. You are yet to provide some key information
          as well as some documents that may be pending for upload.
        </p>
      </div>
      {/* Error Msg Start*/}
      {errCode && (
        <div className="errMsgBlck">
          <ErrMsg>
            {typeof errCode === "number" ? (
              <>
                <span>We are facing some technical issue.</span>
                <span>Please try after sometime (error code:{errCode})</span>
              </>
            ) : (
              <span>{errCode}</span>
            )}
          </ErrMsg>
        </div>
      )}
      {/* Error Msg End*/}
      <div className="wbBtns">
        <div className="wbBtn wbcntn">
          <Button
            btnName="Continue"
            disabled={isLoading}
            isLoading={isLoading}
            onClick={handleContinue}
          />
        </div>
      </div>
    </div>
  );
};

export default StatusContinue;
